<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ OR-12390821390</b></div>
<!--            <div class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #8cc63e">คำสั่งซื้อใหม่</b></div>-->
            <div class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #fdac39">กำลังดำเนินการ</b></div>
            <!--            <div class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: grey">รอการลูกค้าชำระเงิน</b></div>-->
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลพาร์ทเนอร์</b></div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ชื่อพาร์ทเนอร์ : </div>
              <div class="ml-1 mr-3">สาขาเมญ่าเชียงใหม่</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : </div>
              <div class="ml-1 mr-3">0238175826</div>
              <!--              <div v-if="order_header.telephone !== null" class="ml-1 mr-3">{{ order_header.telephone }}</div>-->
              <!--              <div v-else class="ml-1 mr-3">-</div>-->
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img">
              <div>
                <div class=""><b>การตอบกลับจากฟาร์มาแคร์พลัส</b></div>
                <div class="mt-3">
                  <div class="ml-1 mr-3" style="color: #fdac39;">แก้ไขคำสั่งซื้อ : IpsoftAdmin 03/05/2565  11:29 น.</div>
                  <div class="ml-1 mr-3" style="color: #86bc3a;">อนุมัติคำสั่งซื้อ : IpsoftAdmin 03/05/2565  11:29 น.</div>
                </div>
              </div>
              <div class="mt-2 display_mobile">
                <v-btn elevation="5" @click="image_modal = true" class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการสินค้า</b></div>
              <v-divider/>
              <v-data-table class="border_table" :headers="header" :items="data_list" :items-per-page="perPage" hide-default-footer mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="border_table">
                      <div class="mx-auto">
                        <v-img class="mx-auto rounded" v-if="dataDetail.item.product_picture !== null" height="120" width="120" max-width="120" :lazy-src="picture_product" :src="dataDetail.item.product_picture"></v-img>
                        <v-img class="mx-auto rounded" v-else height="120" width="120" max-width="120" :lazy-src="picture_product" :src="picture_product"></v-img>
                      </div>
                    </td>
                    <td class="border_table pa-3">
                      <div v-if="dataDetail.item.product_count !== null"><b>{{ dataDetail.item.product_name }}</b> ({{ dataDetail.item.product_count }})</div>
                      <div v-else><b>{{ dataDetail.item.product_name }}</b></div>
                      <div v-if="dataDetail.item.product_list !== null" >
                        <div v-for="(count, index) in dataDetail.item.product_list" :key="index">
                          <div>{{ count.name }}</div>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center">{{ dataDetail.item.price_per_unit }}</td>
                    <td class="border_table text-center">{{ dataDetail.item.quantity }} {{ dataDetail.item.unit_name }}</td>
                    <td class="border_table text-center">{{ dataDetail.item.total_price }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>ค่าจัดส่ง</b></td>
                    <td class="border_table text-center"><b>{{ format_number(49.00) }}</b></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>รวมทั้งหมด</b></td>
                    <td class="border_table text-center"><b>{{ format_price(123.26) }}</b></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>
          <div class="text-center pa-5 mb-3">
            <v-btn large elevation="5" style="font-size: 18px" @click="edit_product" class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
              <v-icon>mdi-pencil-outline</v-icon> แก้ไขใบจัดของ
            </v-btn>
            <v-btn large elevation="5" style="font-size: 18px" @click="print_product" class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
            </v-btn>
          </div>
        </div>
        <v-dialog v-model="image_modal" max-width="600">
          <v-card>
            <v-form ref="image" @submit.prevent="">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ตรวจสอบการชำระเงิน</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="">
                  <div class="">ยอดชำระ : {{ format_number(100.32) }} บาท </div>
                </div>
                <div class="pa-6">
                  <!--                  <v-img v-if="slip_img.slip_picture !== null" class="mx-auto rounded" height="300" width="300" max-width="300" :lazy-src="picture_holder" :src="slip_img.slip_picture"></v-img>-->
                  <!--                  <v-img v-else class="mx-auto rounded" height="300" width="300" max-width="300" :lazy-src="picture_holder" :src="picture_holder"></v-img>-->
                  <v-img class="mx-auto rounded" height="300" width="300" max-width="300" :lazy-src="picture_holder" :src="picture_holder"></v-img>
                </div>
                <div class="mb-5">
                  <div class="">การชำระเงินของลูกค้า มีการโอนเงินที่ถูกต้องเรียบร้อยดีหรือไม่ ?</div>
                </div>
                <div class="text-right">
                  <v-btn elevation="5" @click="confirm_detail(0)" class="pa-6 grad-success-bg white--text rounded-pill mr-2 ml-2">การโอนเงินถูกต้อง</v-btn>
                  <v-btn elevation="5" @click="in_correct" class="pa-6 grad-danger-bg white--text rounded-pill mr-2 ml-2">ไม่ถูกต้อง</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";
import picture_not_found from "@/assets/image-not-found.png";
import picture_product from "@/assets/pill.png";
// import {HTTP} from "@/axios";
import {formatNumber, formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Confirm_partner_edit",
  data() {
    return {
      loading_page: false,
      picture_holder: picture_holder,
      picture_not_found: picture_not_found,
      picture_product: picture_product,
      perPage: -1,
      image_modal: false,
      order_number: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      header: [
        {
          text: 'รูป',
          value: 'product_img',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '160px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          align: 'left',
          fixed: true,
          width: '500px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price_unit',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          align: 'center',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
      order_header: [],
      slip_img: [],
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    format_price: function(value) {
      return formatPrice(value)
    },
    edit_product() {
      const id = 1
      this.$router.push('/sell/orderpartnereditlots/' + id)
    },
    confirm_detail() {
      this.$router.push('/sell/confirmorderdetail/' + this.$route.params.id)
    },
    print_product() {
      //TODO
    },
  },
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}
.rounded_card {
  border-radius: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
}
.grid_img {
  display: grid;
  grid-template-columns:70% 30%;
}
.border_table {
  border: #e0e0e0 solid 1px
}
.mobile_btn {
  width: 50%;
}
.display_pc {
  display: block;
}
.display_mobile {
  display: none;
}
.mobile_grid {
  width: 25%
}
@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_grid {
    width: 32%
  }
}
@media only screen and (max-width: 500px) {
  .mobile_grid {
    width: 100%;
    margin-bottom: 15px;
  }
  .grid_mx {
    margin: auto;
  }
  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_btn {
    width: 100%;
  }
  .display_pc {
    display: none;
  }
  .display_mobile {
    display: block;
  }
}
</style>
